// Footer.js
import React from 'react';
import {
  ArrowRight, Linkedin
} from 'lucide-react';
import Button from './Button';

const FooterLan = () => {
  const currentYear = new Date().getFullYear();

  // Simplified footer sections to match the main navigation
  const footerSections = [
    { 
      title: "Navigation", 
      links: [ 
        { label: "Our Approach", href: "/approach" }, 
        { label: "Innovation Toolkit", href: "/tools" }, 
        { label: "Resources", href: "/blog" }, 
        { label: "Contact", href: "/contact" } 
      ] 
    },
    { 
      title: "Services", 
      links: [ 
        { label: "Innovation Management", href: "/approach" }, 
        { label: "Future Thinking", href: "/approach" }
      ] 
    },
    { 
      title: "Connect", 
      links: [ 
        { label: "hello@lusidea.com", href: "mailto:hello@lusidea.com" }, 
        { label: "LinkedIn", href: "        https://www.linkedin.com/company/lusidea",
 }, 
        { label: "Zagreb Office", href: "#" } 
      ] 
    }
  ];

  // Spacing container constant
  const SPACING = {
    container: 'max-w-7xl mx-auto px-4 sm:px-6 md:px-8 lg:px-12 xl:px-8'
  };

  // Colors
  const COLORS = {
    primary: '#ce2223',       // Lusidea Red
    primaryDark: '#b01a1b',
    primaryLight: '#f8e7e7',  
    primaryLighter: '#fef2f2',
    secondary: '#fdb52a',     // Accent Yellow/Gold
  };

  return (
    <footer className="bg-gradient-to-br from-primaryLight via-white to-secondaryLight pt-16 sm:pt-20 pb-8 sm:pb-10 relative">
      {/* Decorative top border */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-red-600 via-amber-500 to-red-600"></div>
      
      <div className={SPACING.container}>
        {/* Top section with logo and newsletter */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mb-12 sm:mb-16 pb-10 sm:pb-16 border-b border-gray-200">
          <div>
            <a href="/" className="inline-block mb-6" aria-label="Lusidea Homepage">
              <img 
                src="/logo.svg" 
                alt="Lusidea" 
                className="h-10 sm:h-12"
                width="auto"
                height="48"
              />
            </a>
            <p className="text-lg sm:text-xl text-gray-600 leading-relaxed max-w-md">
              Transforming ideas into impact through human-centered, future-driven innovation.
            </p>
          </div>
          
          <div className="flex flex-col md:flex-row md:justify-end gap-6">
            <div className="max-w-sm">
              <h3 className="text-gray-800 text-lg font-bold mb-3">Get updates</h3>
              <p className="text-gray-600 mb-4 text-base">Subscribe to our innovation newsletter</p>
              <div className="flex">
                <input
                  type="email"
                  placeholder="Your email"
                  className="bg-white border border-gray-300 rounded-l-lg px-4 py-3 text-gray-800 w-full focus:outline-none focus:ring-1 focus:ring-red-500 text-sm"
                />
                <button className="bg-primary hover:bg-primaryDark text-white px-4 py-3 rounded-r-lg transition-colors">
                  <ArrowRight size={18} />
                </button>
              </div>
            </div>
          </div>
        </div>
        
        {/* Links section with improved spacing - Reduced to 3 columns */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-10 mb-12 sm:mb-16">
          {footerSections.map((section, i) => (
            <div key={i}>
              <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wider mb-4">
                {section.title}
              </h3>
              <ul className="space-y-3">
                {section.links.map((link, j) => (
                  <li key={j}>
                    <a
                      href={link.href}
                      className="text-gray-600 hover:text-primary transition-colors group flex items-center text-sm"
                    >
                      <span>{link.label}</span>
                      <ArrowRight className="ml-1 w-3 h-3 opacity-0 group-hover:opacity-100 transform group-hover:translate-x-1 transition-all" />
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom section */}
        <div className="pt-6 flex flex-col md:flex-row justify-between items-center text-center md:text-left border-t border-gray-200">
          <p className="text-gray-500 text-sm">
            &copy; {currentYear} Lusidea d.o.o. All Rights Reserved. Zagreb, Croatia.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <a href="#" className="text-gray-500 hover:text-primary text-sm">Privacy Policy</a>
            <a href="#" className="text-gray-500 hover:text-primary text-sm">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterLan;